<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">تأكيد الإجراء</v-card-title>

        <v-card-text>هل أنت متأكد</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" flat="flat" @click="confirmed=false; dialog = false">لا</v-btn>

          <v-btn color="green darken-1" flat="flat" @click="confirmed=true; dialog = false">نعم</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      confirmed: false
    };
  },
  props: {
    value: Boolean
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
        this.$emit("confirmed", this.confirmed);
      }
    }
  }
};
</script>
